const getStaffConfigQuery = () => {
    return `query EnrollmentQuery {
        getStaffConfig {
            appLinks {
              ampNavLinks {
                linkUrl
                openInNewTab
                text
                sublinks {
                  linkUrl
                  openInNewTab
                  text
                }
              }
            }
            isDistrictTestingCoordinator
          }
        }
      `;
};

export default getStaffConfigQuery;
